<mat-expansion-panel expanded>
  <mat-expansion-panel-header>
    <mat-panel-title>
      {{ 'AUXILIARY_DATA_PANEL.PANEL_TITLE' | translate }}
    </mat-panel-title>
    <mat-panel-description>
      {{ 'AUXILIARY_DATA_PANEL.PANEL_DESCRIPTION' | translate }}
    </mat-panel-description>
  </mat-expansion-panel-header>
  <ng-container
    *ngIf="fieldHandlers$ | async as fieldHandlers; else loadingState"
  >
    <EXP__glxy-wrap>
      <form
        *ngIf="(loadingStatus$ | async) === LoadingStatus.OK"
        [formGroup]="formGroup"
      >
        <ng-container *ngFor="let handler of fieldHandlers">
          <aux-renderer-selector [handler]="handler"></aux-renderer-selector>
        </ng-container>
      </form>
    </EXP__glxy-wrap>
  </ng-container>
</mat-expansion-panel>

<ng-template #loadingState>
  <ng-container *ngIf="(loadingStatus$ | async) === LoadingStatus.LOADING">
    <div class="loading-container">
      <mat-spinner diameter="24" strokeWidth="2"></mat-spinner>
    </div>
  </ng-container>

  <glxy-empty-state *ngIf="(loadingStatus$ | async) === LoadingStatus.ERROR">
    <glxy-empty-state-hero>
      <mat-icon>report_problem</mat-icon>
    </glxy-empty-state-hero>
    <glxy-empty-state-title>
      {{ 'AUXILIARY_DATA_PANEL.ERROR.TITLE' | translate }}
    </glxy-empty-state-title>
    <p>{{ 'AUXILIARY_DATA_PANEL.ERROR.TEXT' | translate }}</p>
    <glxy-empty-state-actions></glxy-empty-state-actions>
  </glxy-empty-state>
</ng-template>
